import React, { useState } from "react";
import { useDispatch } from "react-redux";



// Components
// Redux
import { openModal } from "../../../redux/slices/modalSlice";

// Components
import CalendarInput from "../../../components/CalendarInput/CalendarInput";
import Dropdown from "../../../components/Dropdown/Dropdown";
import Dynamic from "../../../components/DynamicTable/DynamicTable";
import IconAndLabel from "../../../components/IconAndLabel/IconAndLabel";
import LogoWithName from "../../../components/LogoWithName/LogoWithName";
import PaginationTable from "../../../components/PaginationTable/PaginationTable";
import ResultAndCount from "../../../components/ResultAndCount/ResultAndCount";
import SearchBar from "../../../components/SearchBar/SearchBar";
import TabSelector from "../../../components/TabSelector/TabSelector";

// Icons
import { BiLogIn, BiLogOut } from "react-icons/bi";
import { FiEdit } from "react-icons/fi";
import { IoCalendarOutline, IoDocumentTextOutline } from "react-icons/io5";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { MdQrCodeScanner } from "react-icons/md";
import { WiThermometer } from "react-icons/wi";

// Styles
import styles from "./Attendance.module.css";

const Attendance = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");

  const dispatch = useDispatch();

  const handleCheckIn = () => {
    dispatch(openModal("checkInStudent"));
  };
  const handleCheckOut = () => {
    dispatch(openModal("checkOutStudent"));
  };
  const handleEdit = () => {
    dispatch(openModal("editDetails"));
  };
  const handleAbsent = () => {
    dispatch(openModal("absentDetails"));
  };

  const data = [
    {
      _id: "s1",
      date: "02/06/2025-10/06/2025",
      room: "Room 1",
      checkIn: "9:00 AM By Darshan",
      checkOut: "5:00 PM By Darshan",
      absent: "Sick Leave",
      leave: "Sick Leave",
    },
    {
      _id: "s2",
      date: "02/06/2025-10/06/2025",
      room: "Room 1",
      checkIn: "9:00 AM By Darshan",
      checkOut: "5:00 PM By Darshan",
      absent: "Sick Leave",
      leave: "Sick Leave",
    },
  ];
  

  const getColumnData = (data) => {
    return data?.map((item) => {
      const isChecked = selectedIds.includes(item._id);

      const renderCell = (value, type) => (
        <div className={styles.inlineStatus}>
          <span className={styles.time}>{value.split(" By ")[0]}</span>
          <div className={styles.subscriptRow}>
            <span>By {value.split(" By ")[1]}</span>
            <div className={styles.divider}></div>
            <WiThermometer
              className={styles.icon}
              onClick={() => console.log(`${type} Temp clicked`)}
            />
            <IoDocumentTextOutline
              className={styles.icon}
              onClick={() => console.log(`${type} Notes clicked`)}
            />
          </div>
        </div>
      );

      const renderNoteOnly = (value, type) => (
        <div className={styles.inlineStatus}>
          <span className={styles.time}>{value}</span>
          <div className={styles.subscriptRow}>
            <div className={styles.dividerfornote}></div>
            <IoDocumentTextOutline
              className={styles.icon}
              onClick={() => console.log(`${type} Notes clicked`)}
            />
          </div>
        </div>
      );

      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              if (checked) {
                setSelectedIds((prev) => [...prev, item._id]);
              } else {
                setSelectedIds((prev) => prev.filter((id) => id !== item._id));
              }
            }}
          />
        ),
        date: item.date || "-",
        room: item.room || "-",
        checkIn: item.checkIn ? renderCell(item.checkIn, "Check In") : "-",
        checkOut: item.checkOut ? renderCell(item.checkOut, "Check Out") : "-",
        absent: item.absent ? renderNoteOnly(item.absent, "Absent") : "-",
        leave: item.leave ? renderNoteOnly(item.leave, "Leave") : "-",
      };
    });
  };
  
  const columnData = getColumnData(data);


  const headings = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            if (checked) {
              const allIds = data.map((item) => item._id);
              setSelectedIds(allIds);
            } else {
              setSelectedIds([]);
            }
          }}
        />
      ),
      accessor: "checkBox",
    },
    {
      title: <span className={styles.headingBold}>Date</span>,
      accessor: "date",
    },
    {
      title: <span className={styles.headingBold}>Room</span>,
      accessor: "room",
    },
    {
      title: <span className={styles.headingBold}>Check in</span>,
      accessor: "checkIn",
    },
    {
      title: <span className={styles.headingBold}>Check out</span>,
      accessor: "checkOut",
    },
    {
      title: <span className={styles.headingBold}>Marked Absent</span>,
      accessor: "absent",
    },
    {
      title: <span className={styles.headingBold}>Leave</span>,
      accessor: "leave",
    },
  ];
  

  return (
    <div className={styles.wrapper}>
      <div className={styles.resultandcount}>
        <ResultAndCount
          label="Attendance %"
          count={10}
          bgColor="rgba(from var(--Success_Color) r g b / 0.3)"
          textColor="Black_Color"
        />
        <ResultAndCount
          label="Days Present"
          count={2}
          bgColor="rgba(from var(--Primary_Color) r g b / 0.3)"
          textColor="Black_Color"
        />
        <ResultAndCount
          label="Days Absent"
          count={1}
          bgColor="rgba(from var(--Warning_Color) r g b / 0.3)"
          textColor="Black_Color"
        />
     

        <ResultAndCount
          label="Leaves Count"
          count={3}
          bgColor="rgba(from var(--Error_Color) r g b / 0.2)"
          textColor="Black_Color"
        />
      </div>
      <div className={styles.totaltable}>
        <div className={styles.controlsBar}>
         
            <CalendarInput
              label=" Date"
              required
              value={selectedDate}
              onChange={(date) => setSelectedDate(date)}
              background="var(--Utility_Color1)"
              placeholderColor="var(--Primary_Color)"
              iconColor="var(--Grey_Color)"
              borderRadius="12px"
            />
          
        </div>

        <div className={styles.tableBox}>
          <Dynamic
            headings={headings}
            columnData={columnData.slice(
              (currentPage - 1) * itemsPerPage,
              currentPage * itemsPerPage
            )}
          />
          <PaginationTable
            data={columnData}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            setCurrentPage={setCurrentPage}
            setItemsPerPage={setItemsPerPage}
          />
        </div>
      </div>
    </div>
  );
};

export default Attendance;
